module.exports = __webpack_public_path__ + "static/media/BackButton.a524a88c.svg";